import { render, staticRenderFns } from "./jingdianguanli.vue?vue&type=template&id=28f0ab56&scoped=true&"
import script from "./jingdianguanli.vue?vue&type=script&lang=js&"
export * from "./jingdianguanli.vue?vue&type=script&lang=js&"
import style0 from "./jingdianguanli.vue?vue&type=style&index=0&id=28f0ab56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f0ab56",
  null
  
)

export default component.exports